import axios from 'axios';

const cfg = window.RUNTIME_CONFIG || {};

const api = axios.create({
  baseURL: cfg.BASE_API_URL
});

export default api;

export const baseURL = cfg.BASE_API_URL;
export const imageURL = cfg.IMAGE_URL;


